import { useMutation } from "@tanstack/react-query";
import { LastMinuteDealService } from "../../services/last-minute-deal.service";
import { ILastMinuteDealCreateModel } from "../../models/LastMinuteDeal";

export const useLastMinuteDealMutations = () => {
  const { mutate: create } = useMutation<any, Error, ILastMinuteDealCreateModel>({
    mutationFn: async (model) => LastMinuteDealService.create(model),
  });

  const { mutate: update } = useMutation<
    any,
    Error,
    { id: string; model: ILastMinuteDealCreateModel }
  >({
    mutationFn: async ({ id, model }) => LastMinuteDealService.update(id, model),
  });

  const { mutate: remove } = useMutation<any, Error, string>({
    mutationFn: async (id) => LastMinuteDealService.delete(id),
  });

  return {
    create,
    update,
    remove,
  };
};
